<template>
    <Modal :alwaysShow="true" :header="header" @hide="$emit('hide')">
        <form @submit.prevent="save">
            <div class="checkbox">
                <label>
                    <input type="checkbox" v-model="form.is_ban" :disabled="form.saving" />
                    Mark product as banned
                </label>
            </div>

            <div>
                <label>Expires on</label>
                <Datepicker
                    v-model="form.expires_at"
                    class="form-control"
                    :options="{ autoclose: true, todayHighlight: true, format: 'yyyy-mm-dd' }"
                    :disabled="form.saving"
                    />
            </div>

            <FormGroup :form="form" title="Notes" field="notes">
                <textarea class="form-control" v-model="form.notes" :disabled="form.saving" v-autosize v-focus></textarea>
            </FormGroup>
        </form>

        <template slot="footer">
            <button class="btn btn-default" :disabled="form.saving" @click="save">
                Save
            </button>
        </template>
    </Modal>
</template>

<script>
import { generateFormMixins } from '@/utilities/crud/mixins';

export default {
    mixins: [
        generateFormMixins({
            entity: 'productBans',
            header: isNew => isNew ? 'Add Product Note/Ban' : 'Edit Product Note/Ban',
            dontReloadIfLoaded: true,
            fields: {
                id: null,
                product_id: null,
                is_ban: true,
                notes: '',
                expires_at: null,
            },
        }),
    ],
    props: {
        productId: null,
    },
    methods: {
        resetForm() {
            const data = { ...this.productBan };
            if (this.productId) {
                data.product_id = this.productId;
            }
            this.form.reset(data);
        },
        postSave(id) {
            this.$emit('saved', id);
        },
    },
}
</script>
